import type { ListBuilderList } from '../../../types';

/**
 * Pending Fulfillment list configuration
 * Shows requests with items received, pending fulfillment
 */
export const pendingFulfillmentList: ListBuilderList = {
	id: 'default-sourcing-requests-pending-fulfillment',
	cacheTTL: 300000,
	name: 'Pending Fulfillment',
	type: 'default',
	active: true,
	sortOrder: 9,
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestLineStatus: {
			defaultValue: [{ id: 'received', label: 'Received' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
